var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.footerContainer
  }, _vm._l(_vm.getFooterRoutes, function (footerRoute) {
    return _c('FooterItem', {
      key: footerRoute.title,
      attrs: {
        "icon": footerRoute.icon || footerRoute.title,
        "route": footerRoute,
        "label": footerRoute.title,
        "active": footerRoute.title === _vm.routeSidebarItemName
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }